"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReadWriteRecipientWellViewState_1 = require("../store/schema/ReadWriteRecipientWellViewState");
var isValidEmailAddress_1 = require("../utils/isValidEmailAddress");
/*
 * Invokes initializeReadWriteRecipientWellWithFindControl.
*/
function createRecipientWell(initialEmails, contactPickerState) {
    var recipientWell = {
        queryString: '',
        recipients: [],
        isDirty: false,
        shouldShowFindResult: false,
        shouldShowContactPicker: false,
        findResultSet: [],
        findResultType: ReadWriteRecipientWellViewState_1.FindRecipientResultType.None,
        findResultHightlightIndex: -1,
        isSearching: false,
        hasSearchedDirectory: false,
        contactPicker: contactPickerState
            ? contactPickerState
            : { contacts: [], isLoading: false, maxForSession: -1 },
    };
    if (initialEmails) {
        for (var _i = 0, initialEmails_1 = initialEmails; _i < initialEmails_1.length; _i++) {
            var email = initialEmails_1[_i];
            var recipient = {
                displayText: email.Name,
                persona: { EmailAddress: email, PersonaId: email.ItemId },
                isContextMenuOpen: false,
                isValid: isValidEmailAddress_1.default(email.EmailAddress),
                isSelected: false,
                isExpanding: false,
            };
            recipientWell.recipients.push(recipient);
        }
    }
    return recipientWell;
}
exports.default = createRecipientWell;
//# sourceMappingURL=createRecipientWell.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/utils/createRecipientWell.js
// module id = 2046
// module chunks = 2 3 4 45 90 108